import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, makeStyles } from '@material-ui/core';
import { getMuiAlignment } from '../utils';
const setColor = ({ customColor }) => {
    if (customColor) {
        return customColor;
    }
    return '#11305d';
};
const useStyles = makeStyles(({ typography: { pxToRem } }) => ({
    root: {
        fontSize: pxToRem(14),
        fontWeight: 600,
        lineHeight: 1.5,
        color: setColor,
    },
}));
export const TypeTableHeader = (props) => {
    const { 
    // Give default values to props, pull props we don't want to pass through.
    component = 'h4', align = 'leading', customColor, children } = props, 
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "children"]);
    const classes = useStyles(props);
    return (_jsx(Typography, Object.assign({ className: classes.root, component: component, align: getMuiAlignment(align) }, rest, { children: children }), void 0));
};
//# sourceMappingURL=TypeTableHeader.js.map